import { defaultCompanyBlockade } from './state';

/**
 * Actualiza el campo para visualizar el modal.
 *
 * @param {*} state
 * @param {boolean} showModal
 */
export function setModal(state, showModal) {
    state.modal.show = showModal;
}

/**
 * Reinicia el modal a el estado inicial.
 *
 * @param {*} state
 */
export function resetModal(state) {
    state.modal.show = false;
}

/**
 * Actualiza la acción que se desea ejecutar..
 *
 * @param {*} state
 * @param {string} action
 */
export function setAction(state, action) {
    state.action = action;
}

/**
 * Reinicia la accion asu estado inicial.
 *
 * @param {*} state
 */
export function resetAction(state) {
    state.action = null;
}

/**
 * Actualiza el objeto company blockade.
 *
 * @param {*} state
 * @param {*} companyBlockades
 */
export function setCompanyBlockades(state, companyBlockades) {
    state.companyBlockades = companyBlockades;
}

/**
 * Agrega el identificador de una empresa al objeto companyBlockades.
 *
 * @param {*} state
 * @param {number} companyId
 */
export function setCompanyId(state, companyId) {
    state.companyBlockade.slq_company_id = companyId;
}

/**
 * Reinicia el objeto companyBlockade.
 *
 * @param {*} state
 */
export function resetCompanyBlockade(state) {
    state.companyBlockade = defaultCompanyBlockade();
}

/**
 * Actualiza el objeto empresa sobre el que se esta trabajando.
 *
 * @param {*} state
 * @param {*} company
 */
export function setCompany(state, company) {
    state.company = company;
}

/**
 * Actualiza el objeto empresa a su estado inicial.
 *
 * @param {*} state
 * @param {*} company
 */
export function resetCompany(state) {
    state.company = null;
}

/**
 * agrega el typo en el bloqueo de empresas.
 *
 * @param {*} state
 * @param {*} type
 */
export function addTypeCompanyBlockade(state, type) {
    state.companyBlockade.type = type;
}
